@if (schedules()?.length) {
  <div [ngClass]="{ 'compact-container': isCompactMode(), '': !isCompactMode() }">
    <button mat-button (click)="onClickSchedule()">View schedule</button>
  </div>
}
